export default {
  rebel: {
    phone: '1-844-548-2157',
    email: 'service@rebel.com',
    abuse: 'abuse@rebel.com',
  },
  internic: {
    phone: '1-866-642-1232',
    email: 'service@internic.ca',
    abuse: 'abuse@internic.ca',
  },
}
